import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';
import { Capacitor } from '@capacitor/core';

// Helper function to convert Blob to base64 safely
const blobToBase64 = (blob) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = reject;
    reader.onload = () => {
      const dataUrl = reader.result;
      resolve(dataUrl.split(',')[1]); // base64 without data: prefix
    };
    reader.readAsDataURL(blob);
  });

const mobileExportCsv = async (blob, name, extension) => {
  try {
    const timestamp = new Date().toISOString().replace(/[:.-]/g, '_');
    const fileName = `${name}_${timestamp}.${extension}`;
    const base64Data = await blobToBase64(blob);

    const file = await Filesystem.writeFile({
      path: fileName,
      data: base64Data,
      directory: Directory.Documents,
      encoding: Encoding.BASE64,
    });

    const fileUri = file.uri;

    if (Capacitor.getPlatform() === 'ios') {
      // On iOS, share the file URI
      await Share.share({
        title: 'Export File',
        url: fileUri,
        dialogTitle: 'Share your CSV file',
      });
    } else {
      // On Android, alert success (can add sharing if needed)
      alert(`${extension.toUpperCase()} file saved to Documents folder.`);
    }

    return file;
  } catch (error) {
    console.error('Error saving file to filesystem:', error);
    throw new Error('Failed to save file');
  }
};
export default mobileExportCsv;
